import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { legalContent } from "@/lib/legal";

export default function LegalModal({ type, onClose }) {
  const { t, lang } = useLang();
  const open = type === "privacy" || type === "terms";
  const sections = open ? legalContent[lang][type] : [];
  const title = type === "privacy" ? t.legal.privacyTitle : t.legal.termsTitle;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center p-0 sm:p-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="legal-modal"
        >
          <div className="absolute inset-0 bg-ink/60 backdrop-blur-sm" onClick={onClose} />
          <motion.div
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 40, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="relative bg-paper text-ink w-full sm:max-w-2xl max-h-[85vh] rounded-t-xl sm:rounded-xl overflow-hidden flex flex-col"
          >
            <div className="flex items-center justify-between px-6 py-5 border-b border-line">
              <h3 className="font-serif text-2xl tracking-tight">{title}</h3>
              <button onClick={onClose} aria-label={t.legal.close} className="p-2 -mr-2 hover:opacity-60 transition-opacity" data-testid="legal-close">
                <X size={22} strokeWidth={1.5} />
              </button>
            </div>
            <div className="overflow-y-auto px-6 py-6 space-y-6">
              {sections.map((s, i) => (
                <div key={i}>
                  <h4 className="font-medium text-base">{s.h}</h4>
                  <p className="mt-1.5 text-sm text-stone leading-relaxed">{s.p}</p>
                </div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
